<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.2242 1.66141C15.538 1.83635 15.692 2.20274 15.5975 2.54934L13.5229 10.1563H21.0938C21.4049 10.1563 21.6863 10.3408 21.8103 10.6262C21.9343 10.9115 21.8772 11.2432 21.6649 11.4706L10.7274 23.1893C10.4823 23.452 10.0896 23.5136 9.77584 23.3386C9.46205 23.1637 9.30802 22.7973 9.40255 22.4507L11.4772 14.8438H3.90627C3.59518 14.8438 3.31373 14.6592 3.18975 14.3739C3.06576 14.0886 3.12287 13.7569 3.33513 13.5295L14.2726 1.81072C14.5178 1.54808 14.9104 1.48647 15.2242 1.66141Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgFlash',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>